import { render, staticRenderFns } from "./dbxcDialog.vue?vue&type=template&id=3c197acf&scoped=true&"
import script from "./dbxcDialog.vue?vue&type=script&lang=js&"
export * from "./dbxcDialog.vue?vue&type=script&lang=js&"
import style0 from "./dbxcDialog.vue?vue&type=style&index=0&id=3c197acf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c197acf",
  null
  
)

export default component.exports